import React from 'react';
import BaseDetailPage from '../../../_CustomComponents/BaseDetailPage';
import { Navigate } from "react-router-dom";
import { Portlet, PortletBody, PortletHeader } from "../../../../../partials/content/Portlet";
import PortletSpinner from '../../../../../partials/layout/PortletSpinner';
import * as internalEstimateCrud from '../../../../../crud/internalEstimate.crud';
import { Alert } from "react-bootstrap";
import PageToolbar from '../../../_CustomComponents/PageToolbar';
import { withDetailPageProps } from '../../../../../shared/hoc/withDetailPageProps';
import BiDynamicForm from '../../../../../partials/layout/BiDynamicForm';
import DxDialogModal from '../../../../../partials/content/dxControls/dxDialogModal';

const initialState = {
    notification: null,
    files: null,
    loading: true,
    saving: false,
    estimateHistory: null,
    //activeEstimate: null,
    showModal: false,
    modalTitle: '',
    modalText: '',
    modalMode: ''
};

/**
 * Generic Internal Estimate Detail Component
 * Works with any parent workflow (CE, EW, Instruction, Proposal)
 */
class InternalEstimateDetailPage extends BaseDetailPage {
    constructor(props) {
        super(props);

        this.updateFormConfig = {
            currencyCode: this.props.contract.currency,
            buttonResource: "GENERAL.FORMS.BUTTON_MARK_AS_SUPERSEDED",
            fields: [
                { label: props.workflowItem.fields.PriceImpact.label, dataField: 'priceimpact', editorType: 'dxNumberBox' },
                { label: props.workflowItem.fields.TimeImpact.label, dataField: 'timeimpact', editorType: 'dxNumberBox', editorOptions: { format: '#,##0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_DAYS' }), placeholder: '0 ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_DAYS' }) }, validation: { type: 'range', min: -36525, max: 36525, warning: this.props.intl.formatMessage({ id: 'ASSESSMENT.FORM.INVALID_DATE' }, { VALUE: 36525 }) } },
                { label: props.workflowItem.fields.InternalNotes.label, dataField: 'internalnotes', editorType: 'dxTextArea' }
            ]
        };

        this.state = { ...initialState };
        this.printIssueDivRef = React.createRef();
    }

    componentDidMount() {
        this.fetchEstimate();
        //this.fetchHistory();
    }

    componentDidUpdate(prevProps) {
        if (this.props.params.estimateid !== prevProps.params.estimateid) {
            this.setState({ ...initialState }, () => {
                this.fetchEstimate();
                //this.fetchHistory();
            });
        }
    }

    fetchEstimate = () => {
        internalEstimateCrud.getInternalEstimate(this.props.params.estimateid)
            .then(response => {
                const estimate = response.data;
                if (estimate.contractid !== this.props.contract.contractid) {
                    throw new Error(this.props.intl.formatMessage({ id: 'GENERAL.FORMS.INVALID_URL' }));
                }
                this.setState({
                    notification: estimate,
                    loading: false
                });
                //this.checkActiveEstimate(estimate.lineageid);
            })
            .catch(error => {
                console.error('Error fetching estimate:', error);
                this.setState({ loading: false });
            });
    };

    // fetchHistory = () => {
    //     const estimate = this.state.notification;
    //     if (!estimate?.lineageid) return;

    //     internalEstimateCrud.getInternalEstimateHistory(estimate.lineageid)
    //         .then(response => {
    //             this.setState({
    //                 estimateHistory: response.data || []
    //             });
    //         })
    //         .catch(error => {
    //             console.error('Error fetching history:', error);
    //         });
    // };

    // checkActiveEstimate = (lineageid) => {
    //     internalEstimateCrud.getActiveEstimate(lineageid)
    //         .then(response => {
    //             this.setState({
    //                 activeEstimate: response.data
    //             });
    //         })
    //         .catch(error => {
    //             console.error('Error fetching contributing estimate:', error);
    //         });
    // };

    showModal = (mode, setSubmitting, e) => {
        const statusText = this.props.intl.formatMessage({ id: "GENERAL.INTERNALESTIMATE.MODAL.SUPERSEDING" });

        this.setState({
            showModal: true,
            modalTitle: this.props.intl.formatMessage({ id: "GENERAL.INTERNALESTIMATE.MODAL.TITLE" }),
            modalText: statusText,
            modalMode: mode,
            formSetSubmitting: setSubmitting
        });
    }

    onModalResponse = (response, params) => {
        const { formSetSubmitting } = this.state;

        this.setState({ showModal: false }, () => {
            if (response === 'OK') {
                this.confirmMarkSuperseded();
            } else if (response === 'CANCEL') {
                if (typeof formSetSubmitting === 'function') {
                    formSetSubmitting(false);
                }
            }
        });
    }

    confirmMarkSuperseded = () => {
        const { notification } = this.state;

        internalEstimateCrud.markEstimateSuperseded(
            notification.internalestimateid
        )
            .then(() => {
                this.setState({
                    saving: false,
                    showModal: false,
                    formSetSubmitting: null,
                    notification: { ...notification, status: 'SUPERSEDED' }
                });
                //this.fetchHistory();
                //this.checkActiveEstimate(notification.lineageid);
                this.fetchEstimate();
                this.props.onParentChanged();
            })
            .catch(error => {
                this.props.enqueueSnackbar(error.toString(), { variant: 'error', });

                // Also release the spinner if the API backend fails entirely
                if (typeof this.state.formSetSubmitting === 'function') {
                    this.state.formSetSubmitting(false);
                }

                this.setState({ saving: false });
            }); 
    }

    renderToolbar = () => {
        const saveDisabled = (this.state.saving || this.state.showModal);
        return (
            <PageToolbar
                key={this.state.notification.internalestimateid}
                documentIsFinal={false}
                saveDisabled={saveDisabled}
                workflowItem={this.props.workflowItem}
                parentWorkflowItem={this.props.parentWorkflowItem}
                referenceid={this.state.notification.referenceid}
                contract={this.props.contract}
                notification={this.state.notification}
            />
        );
    };

    // updateInternalEstimate = async (estimate, setSubmitting) => {
    //     await internalEstimateCrud.updateInternalEstimate(estimate)
    //     .then(() => {
    //         this.props.enqueueSnackbar('Internal estimate updated successfully', { variant: 'success', });
    //         this.fetchEstimate();
    //         this.props.onParentChanged();
    //         setSubmitting(false);
    //     })
    //     .catch(error => {
    //         this.props.enqueueSnackbar(error.toString(), { variant: 'error', });
    //         setSubmitting(false);
    //     });
    // }

    render() {
        const { notification } = this.state;

        if (!notification) {
            return (<PortletSpinner />);
        }

        if (!notification) {
            return <Navigate replace to={this.props.workflowItem.paths.defaultPath} />;
        }

        const isSuperseded = notification.status === 'SUPERSEDED' || notification.status === 2 || notification.status === '2';
        const isActive = notification.status === 1 || notification.status === '1' || notification.status === 'Active';

        // const secondaryButtonProps = {}
        // secondaryButtonProps.secondaryButtonEnabled = isActive;
        // secondaryButtonProps.secondaryButtonActive = isActive;
        // secondaryButtonProps.secondaryButtonDeactiveText = this.props.intl.formatMessage({ id: "GENERAL.FORMS.BUTTON_MARK_AS_SUPERSEDED" });
        // secondaryButtonProps.secondaryButtonHandler = this.showModal;
        // secondaryButtonProps.secondaryButtonDeactiveStyle = { backgroundColor: '#f44336', marginLeft: "10px" };

        return (
            <Portlet>
                <PortletHeader
                    title={this.props.intl.formatMessage({ id: "GENERAL.INTERNALESTIMATE.OVERVIEW.TITLE" })}
                    toolbar={this.renderToolbar()}
                />
                <PortletBody style={{ maxWidth: 800 }}>
                    {isSuperseded && (
                        <Alert variant="warning">
                            <strong>Superseded for Internal Forecasting:</strong>&nbsp; This estimate has been superseded and no longer contributes to forecast totals. It remains visible for audit purposes.
                        </Alert>
                    )}
                    {isActive && !isSuperseded && (
                        <Alert variant="success">
                            <strong>Contributing to Forecast:</strong>&nbsp; This is the active estimate contributing to the Change Lineage forecast.
                        </Alert>
                    )}
                    {!isActive && !isSuperseded && (
                        <Alert variant="warning">
                            <strong>Not Currently Contributing:</strong>&nbsp; A higher-priority estimate is currently contributing to forecasts.
                        </Alert>
                    )}
                    <BiDynamicForm
                        key={`${notification.internalestimateid}_${notification.status}`}
                        item={notification}
                        config={this.updateFormConfig}
                        onSubmitHandler={isActive ? this.showModal : null}
                        disabled={isActive ? false : true}
                        //{...secondaryButtonProps}
                    />
                </PortletBody>
                <DxDialogModal
                    visible={this.state.showModal}
                    title={this.state.modalTitle}
                    text={this.state.modalText}
                    mode={'SUPERSEDE'}
                    onDialogResult={this.onModalResponse}
                />
            </Portlet>
        );
    }
}

export default withDetailPageProps(InternalEstimateDetailPage);
